import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const baseUrl = `${import.meta.env.VITE_USER_SERVICE_URL}/users`;
const baseUrlV2 = `${import.meta.env.VITE_USER_SERVICE_URL}/v2/users`;
export const axiosInstance = buildAxiosInstance(baseUrl);
export const axiosInstanceV2 = buildAxiosInstance(baseUrlV2);
export const axiosUser = buildMakeUseAxios(baseUrl);
export const axiosUserV2 = buildMakeUseAxios(baseUrlV2);
